const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;
const MONTH = 30 * DAY;
const YEAR = 365 * DAY;

const INTERVALS = {
  minute: MINUTE,
  min: MINUTE,
  hour: HOUR,
  day: DAY,
  week: WEEK,
  month: MONTH,
  year: YEAR,
};

const pluralize = (count, word) => `${word}${Math.round(count) === 1 ? '' : 's'}`;

const intervalsAgo = (difference, word) => {
  const numIntervals = difference / INTERVALS[word];
  const timeDisplay = `${Math.round(numIntervals)} ${pluralize(numIntervals, word)} ago`;

  return timeDisplay;
};

const intervals = (difference, word) => {
  const numIntervals = difference / INTERVALS[word];
  const timeDisplay = `${Math.round(numIntervals)} ${pluralize(numIntervals, word)}`;
  return timeDisplay;
};

const dateAndDifference = (dateString, date = new Date(dateString)) => {
  const difference = Math.abs(new Date() - date) / 1000;
  return {date, difference};
};

const timeAgo = (dateString, options = {}) => {
  const {difference} = dateAndDifference(dateString);
  let word = 'year';

  if (difference < MINUTE) {
    return 'Just now';
  } else if (difference < HOUR) {
    word = options.shortText ? 'min' : 'minute';
  } else if (difference < DAY) {
    word = 'hour';
  } else if (difference < WEEK) {
    word = 'day';
  } else if (difference < WEEK * 10) {
    word = 'week';
  } else if (difference < YEAR) {
    word = 'month';
  }
  return options.removeAgo ? intervals(difference, word) : intervalsAgo(difference, word);
};

export const detailedTimeAgo = (dateString) => {
  // This is for messaging style date shorthand
  // displays Time, Weekday, Date, or Date and Year depending on elapsed time
  const {date, difference} = dateAndDifference(dateString);

  if (difference < HOUR) {
    return timeAgo(dateString, {removeAgo: true, shortText: true});
  } else if (difference < DAY) {
    return date.toLocaleString('default', {hour: 'numeric', minute: 'numeric'});
  } else if (difference < WEEK) {
    return date.toLocaleString('default', {weekday: 'short'});
  } else if (difference < WEEK * 10) {
    return date.toLocaleString('default', {month: 'short', day: 'numeric'});
  } else {
    return date.toLocaleString('default', {month: 'numeric', day: 'numeric', year: '2-digit'});
  }
};

export const detailedTimestamp = (dateString) => {
  // displays day, date and year, and time
  const {date} = dateAndDifference(dateString);

  const dateYearString = date.toLocaleString('default', {
    weekday: 'short',
    month: 'numeric',
    day: 'numeric',
    year: '2-digit',
  });
  const time = date.toLocaleString('default', {hour12: true, hour: 'numeric', minute: 'numeric'});
  return `${dateYearString} at ${time}`;
};

export const monthDayTimestamp = (dateString, withoutTime = false) => {
  const date = new Date(dateString);
  const monthDayString = date.toLocaleDateString('default', {month: 'short', day: 'numeric'});
  const time = date.toLocaleString('default', {hour12: true, hour: 'numeric', minute: 'numeric'});
  const isToday = new Date().toDateString() === date.toDateString();

  return `${isToday ? 'today' : monthDayString}${withoutTime ? '' : ` at ${time}`}`;
};

export default timeAgo;
